import { applyTwoDecimals, applyScientific } from 'adapter/in/common/utils/numberFormatter';

export const handleUnitAndValue = (
    unit: string,
    value: string,
    maxChars: number,
    decimalSeparator: string,
    thousandSeparator: string,
    hasData: boolean
): { formattedValue: string; formattedUnit: string } => {
    let formattedValue = applyTwoDecimals(value, decimalSeparator, thousandSeparator);
    let formattedUnit = unit;

    if (!hasData) {
        return { formattedValue: '-', formattedUnit: unit };
    }

    if (unit.length + formattedValue.length > maxChars) {
        let unitMaxChars = Math.floor((maxChars / 100) * 40); // as a general rule we leave the unit a 40% of available space
        let valueMaxChars = Math.floor((maxChars / 100) * 60); // as a general rule we leave the unit a 60% of available space
        let exponential;
        if (formattedValue.length <= maxChars - unitMaxChars) {
            unitMaxChars = maxChars - formattedValue.length;

            formattedUnit = `${unit.substring(0, unitMaxChars - 3)}...`;
        } else if (unit.length >= unitMaxChars) {
            const exponentialSpaceNeeded = value.length > 10 ? 6 : 5;
            exponential = valueMaxChars - exponentialSpaceNeeded;

            formattedValue = applyScientific(parseFloat(value), decimalSeparator, exponential);
            unitMaxChars = maxChars - formattedValue.length;
            formattedUnit = `${unit.substring(0, unitMaxChars - 3)}...`;
        } else {
            valueMaxChars = maxChars - unit.length;
            const exponentialSpaceNeeded = value.length > 10 ? 6 : 5;
            exponential = valueMaxChars - exponentialSpaceNeeded;

            formattedValue = applyScientific(parseFloat(value), decimalSeparator, exponential);
        }
    }

    return { formattedValue, formattedUnit };
};
